import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { gameSizesConfig, gridOptions, perChunk } from './helpers';
import { Category } from '@/api/games';
import { Button } from '@/components/buttons';
import { GamesGridStatic } from '@/components/GamesGrid';
import { MediaType } from '@/helpers/enums';
import { useNavigation } from '@/hooks/navigation';
import { useResponsive } from '@/modules/client';
import { useCMSGameCategories } from '@/modules/lobby/hooks';
import { useCommonStore } from '@/store';

import { ScGamesSection } from './styled';

export const GamesSection = () => {
  const { t } = useTranslation('jackpot');
  const { currentMediaType } = useResponsive();
  const { generateLink } = useNavigation();

  const { categories: gameCategoriesList } = useCMSGameCategories();

  const { gamesByCategories, pendingGamesByCategories, getGamesByCategory } =
    useCommonStore(
      useShallow((state) => ({
        gamesByCategories: state.gamesByCategories,
        pendingGamesByCategories: state.pendingGamesByCategories,
        getGamesByCategory: state.getGamesByCategory,
      }))
    );

  const amountGames = useMemo(() => {
    switch (currentMediaType) {
      case MediaType.DESKTOP_L:
        return perChunk.desktopL;
      case MediaType.TABLET:
        return perChunk.tablet;
      case MediaType.MOBILE:
        return perChunk.mobile;
      case MediaType.MOBILE_S:
        return perChunk.mobileS;
      case MediaType.DESKTOP:
      default:
        return perChunk.desktop;
    }
  }, [currentMediaType]);

  useEffect(() => {
    gameCategoriesList.length &&
      getGamesByCategory(Category.TOP, {
        pageSize: amountGames,
        staticAmount: true,
      });
  }, [getGamesByCategory, amountGames, gameCategoriesList]);

  const topGames = useMemo(
    () => gamesByCategories[Category.TOP]?.games || [],
    [gamesByCategories]
  );

  return (
    <ScGamesSection>
      <div className="title">{t('jackpotGames')}</div>
      <div className="games">
        <GamesGridStatic
          games={topGames}
          gridOptions={gridOptions}
          perChunkObj={perChunk}
          gameSizesConfig={gameSizesConfig}
          loading={pendingGamesByCategories[Category.TOP]}
          noShowMore
        />
      </div>
      <div className="btn-container">
        <Button
          primary
          wide
          small
          to={generateLink('/games/trending#gamesSection')}
        >
          {t('button.more')}
        </Button>
      </div>
    </ScGamesSection>
  );
};
